/* eslint-disable max-len */
import React from 'react';
import { Color } from '../../../config/Color';

type Props = { color?: string };
/**
 *
 * @param color - color of the circle containing a white tick
 * @returns
 */
export function QuestionMarkColorable(props: Props): JSX.Element {
  const { color } = props;
  return (
    <svg width="26" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13.8281" cy="13" r="13" fill={color ?? Color.state.success} />
      <path
        d="M14.3214 15.06H12.9214C12.9074 14.878 12.8934 14.724 12.8934 14.528C12.8934 13.688 13.2154 13.002 14.0274 12.414L14.6714 11.952C15.1334 11.616 15.3294 11.21 15.3294 10.734C15.3294 10.006 14.8394 9.32 13.8174 9.32C12.7814 9.32 12.2354 10.118 12.2354 10.916C12.2354 11.126 12.2634 11.392 12.3194 11.546L10.7374 11.434C10.6814 11.238 10.6534 11.014 10.6534 10.79C10.6534 9.39 11.7034 7.864 13.8174 7.864C15.8894 7.864 17.0094 9.236 17.0094 10.664C17.0094 11.77 16.4214 12.554 15.6094 13.128L15.0074 13.548C14.5454 13.87 14.3074 14.332 14.3074 14.878C14.3074 14.906 14.3074 14.976 14.3214 15.06ZM12.6134 17.076C12.6134 16.516 13.0614 16.04 13.6354 16.04C14.1954 16.04 14.6574 16.516 14.6574 17.076C14.6574 17.636 14.1954 18.098 13.6354 18.098C13.0614 18.098 12.6134 17.636 12.6134 17.076Z"
        fill="white"
      />
    </svg>
  );
}
